import { TipoEnlace } from './../../models/farmacia-enlace.interface';
import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { FarmaciaEnlace } from 'src/app/models/farmacia-enlace.interface';
import { EnlacesService } from 'src/app/services/enlaces.service';
import { BaseComponent } from '../base.component';
import { HttpResponse } from '@angular/common/http';
import { Location } from '@angular/common';

@Component({
  selector: 'app-farmacias',
  templateUrl: './farmacias.component.html',
  styleUrls: ['./farmacias.component.scss']
})
export class FarmaciasComponent extends BaseComponent implements OnInit {

  farmaciasEnlace$: Observable<FarmaciaEnlace[] | null> = this.enlacesService.getFarmaciasEnlace$()
    .pipe(
      map((farmacias) => {
        console.log(farmacias);
        return farmacias;
      })
    );
  updatingFarmaciasEnlace$: Observable<boolean> = this.enlacesService.getUpdatingFarmaciasEnlace$();

  constructor(private activatedRoute: ActivatedRoute,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private enlacesService: EnlacesService,
    private _location: Location) {
    super(_location);

    this.matIconRegistry.addSvgIcon(
      `whatsapp`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/iconos/whatsapp-brands.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      `instagram`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/iconos/instagram-brands.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      `telegram`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/iconos/telegram-plane-brands.svg'
      )
    );
  }

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: Params) => {
        if (params.ciudadId) {
          this.enlacesService.getFarmaciasEnlaceAPI(params.ciudadId, this.ngUnsubscribe);
        }
      })
  }

  public onClick(farmacia: FarmaciaEnlace, tipoEnlace: TipoEnlace): void {
    this.enlacesService.postHistorialFarmaciaAPI({ idFarmacia: farmacia.idFarmacia, tipoEnlace: tipoEnlace.descripcion })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe();

    window.open(`${tipoEnlace.enlace}${tipoEnlace.usuario}`, '_blank');
  }

}
